import { NoTransformConfigurationError } from './transformers/NoTransformConfigurationError.mjs';

/**
 * @internal
 */
function metadata() {
    NoTransformConfigurationError("reflect.metadata");
}
function name() {
    NoTransformConfigurationError("reflect.name");
}

export { metadata, name };
//# sourceMappingURL=reflect.mjs.map
